let constGlobal = {};
// 院校类型
constGlobal.schoolType = [
    {
        key: null,
        value: '院校类型(全部)'
    },
    {
        key: 1,
        value: '自考院校'
    },
    {
        key: 2,
        value: '成教院校'
    },
    {
        key: 3,
        value: '开放教育'
    }
]
// 报考形式
constGlobal.testModality = [
    {
        key: null,
        value: '报考形式(全部)'
    },{
        key: 1,
        value: '面向社会开考'
    },
    {
        key: 2,
        value: '面向助学班开考'
    },
    {
        key: 3,
        value: '系统委托开考'
    }
]
//文章来源
constGlobal.articleSource = [
    {
        key: null,
        value: '文章来源(全部)'
    },{
        key: 1,
        value: '湖北专升本网'
    },
    {
        key: 2,
        value: '湖北专升本论坛'
    },
    {
        key: 3,
        value: '院校教务处'
    },
    {
        key: 4,
        value: '湖北省教育厅'
    },
    {
        key: 5,
        value: '院校招生网'
    },
    {
        key: 6,
        value: '网络转载'
    }
]
// 所属类别
constGlobal.categoryList = [
    {
        key: null,
        value: '所属类别(全部)'
    },
{
    key: 9,
    value: '普通专升本'
},
{
    key: 10,
    value: '自考专升本'
},
{
    key: 11,
    value: '成考专升本'
},
{
    key: 51,
    value: '开放教育'
}
]
// 院校类别
constGlobal.SchoolCategoryList = [
    {
        key: null,
        value: '院校类别(全部)'
    },{
    key: 10,
        value: '自考院校'
    },
    {
        key: 11,
        value: '成教院校'
    },
    {
        key: 51,
        value: '开放教育'
    }
]
export default constGlobal